import { api } from './api';

/**
 * Verify Jira credentials before saving them. Returns the resolved account's
 * display name on success; throws on failure so the caller can surface the
 * server's message inline.
 *
 * @param {Object} params
 * @param {string} params.url
 * @param {string} params.username
 * @param {string} params.apiToken
 * @returns {Promise<{ ok: boolean, displayName?: string }>}
 */
export const verifyJira = async ({ url, username, apiToken }) => {
  const res = await api.post('/onboarding/verify-jira', { url, username, apiToken });
  return res.data;
};

/**
 * Complete first-time onboarding by creating the user's first organization with
 * the chosen methodology. Optionally connects Jira at the org level. The server
 * sets the user's onboardingCompletedAt and returns the created org plus the
 * updated user.
 *
 * @param {Object} params
 * @param {string} params.organizationName
 * @param {'scrum'|'shape-up'} params.methodology
 * @param {Object} [params.jira] Optional Jira connection ({ url, username, apiToken, projectKey?, storyPointFieldId? }).
 * @returns {Promise<{ organization: Object, user: Object }>}
 */
export const completeOnboarding = async ({ organizationName, methodology, jira }) => {
  const body = { organizationName, methodology };
  if (jira) body.jira = jira;
  const res = await api.post('/onboarding/complete', body);
  return res.data;
};
